import { DatePipe, getNumberOfCurrencyDigits } from '@angular/common';
import { Component, Inject, OnInit, ViewChild } from '@angular/core';
import { AbstractControl, FormControl, FormGroup, Validators } from '@angular/forms';
import {MatDialog as MatDialog,MatDialogRef as MatDialogRef, MAT_DIALOG_DATA as MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Router } from '@angular/router';

import { DATE } from 'ngx-bootstrap/chronos/units/constants';
import { map, switchMap } from 'rxjs/operators';
//import { Days } from '../../shared/enums/enums';
import { UserApiService } from '../../user-api.service';
import { ToastrService } from 'ngx-toastr';
import { Days } from 'src/app/shared/enums/enums';

@Component({
  selector: 'app-add-edit-user-working-hours',
  templateUrl: './add-edit-user-working-hours.component.html',
  styleUrls: ['./add-edit-user-working-hours.component.css'],
  providers: [DatePipe]
})
export class AddEditUserWorkingHoursComponent implements OnInit {
  @ViewChild('myselect', { static: true }) myselect

  constructor(private router: Router,
    private userService: UserApiService,
    private dialog: MatDialog,
     private snotifyService: ToastrService,
    private dialogRef: MatDialogRef<AddEditUserWorkingHoursComponent>,
    private datPipe: DatePipe,
    @Inject(MAT_DIALOG_DATA) data
  ) {
    this.workingHoursId = data.id
    this.InitToDate.setMinutes(this.InitToDate.getMinutes() + 50);
  }

  selectSettings = {
    singleSelection: false,
    text: "Select day",
    selectAllText: 'Select All',
    unSelectAllText: 'UnSelect All',
    primaryKey: "key",
    labelKey: "value",
    noDataLabel: "day...",
    enableSearchFilter: true,
  }
  workingHoursId = 0;
  InitToDate = new Date();
  form = new FormGroup({
    id: new FormControl(0),
    customerGroupId: new FormControl(null, [Validators.required]),
    day: new FormControl([], [Validators.required]),
    fromTime: new FormControl(new Date(), [Validators.required]),
    toTime: new FormControl(this.InitToDate, [Validators.required]),
  }, [this.fromTimeValidity]);
  listDays: any[] = []
  isInValid = false;
  userGroupArray: any[] = [];
  selectedDays = [];
  arrayOfEditDays = []
  ngOnInit() {

    if (this.workingHoursId && this.workingHoursId != 0) {
      this.getUserGroupById()
    }
    for (const key in Days) {
      if (typeof (Days[key]) == 'number') {

        this.listDays.push({
          key: Days[key],
          value: key
        })

      }

    }
    this.isInValid = false
    this.getUserGroup()
  }
  close() {
    this.dialogRef.close();
  }
  getUserGroupById() {

    this.userService.getWorkingHoursById(this.workingHoursId).pipe(map((res: any) => {

      return {
        id: this.workingHoursId,
        customerGroupId: res.customerGroupId,
        day: res.day.map((x) => {
          return {
            key: x.id,
            value: x.name
          }
        }
        ),
        fromTime: res.fromTime,
        toTime: res.toTime,

      }
    })).subscribe((res: any) => {
      this.form.patchValue({
        ...res
      })
    })

  }
  submit() {
    if (this.form.invalid) {
      this.form.markAllAsTouched()
      return;
    }
    let newFromTime = this.datPipe.transform(new Date(this.form.value.fromTime), 'h:mm a')
    let newToTime = this.datPipe.transform(new Date(this.form.value.toTime), 'h:mm a')
    // 
    let multiDaysSelectedArray = this._getDay.value
    let arrayOfDays = []
    for (let index = 0; index < multiDaysSelectedArray.length; index++) {
      arrayOfDays.push(multiDaysSelectedArray[index].key)
    }

    //  this.listDays.push({ key: this._getDay });
    this.userService.upsertWorkingHours({
      ...this.form.value,
      fromTime: newFromTime,
      toTime: newToTime,
      day: arrayOfDays
    })
      .subscribe((res) => {
        this.snotifyService.success('', 'Saved Successfully');
        this.dialogRef.close(true);


      }, error => {
        this.snotifyService.error(error.message, 'Something Went Wrong ')
      }
      )
  }



  getUserGroup() {
    this.userService.getCustomerGroups().subscribe((res) => {
      if (res) {
        this.userGroupArray = res.map((el) => {
          return ({ id: el.id, name: el.name })
        })
      }
    })
  }

  addGroup(value) {
    let valueInput = { id: 0, name: value }
    // let unique = this.userGroupArray.find((el)=>el.name == value)
    // unique.disabled = true 
    // this.userGroupArray = unique
    // this.userService.addCustomergroups({ ...valueInput, fireBaseTopic: "", isActive: true, description: '' }).subscribe((res: any) => {
    // for (let index = 0; index < this.userGroupArray.length; index++) {
    //   if(res == this.userGroupArray[index].name){
    //     this.userGroupArray[index].disabled = true
    //   }
    // }
    // let newId = res.id
    // this.userGroupArray.push({ ...valueInput, id: newId });
    // this._getUserGroupId.setValue(newId)
    // this.myselect.select(valueInput.id)
    return valueInput;
    // })
  }

  fromTimeValidity(control: AbstractControl): { [key: string]: boolean } | null {

    if (control.value.fromTime && control.value.toTime) {

      let fromTime = new Date(control.value.fromTime).getHours();
      let toTime = new Date(control.value.toTime).getHours();
      let fromTimeMinutes = new Date(control.value.fromTime).getMinutes()
      let toTimeMinutes = new Date(control.value.toTime).getMinutes()
      if (fromTime == toTime) {
        if (fromTimeMinutes > toTimeMinutes) {
          return { 'ealierError': true }
        } else if (fromTimeMinutes == toTimeMinutes) {
          return { 'sameTime': true }
        }
      }
      if ((fromTime / 12) > 1 && (toTime / 12) <= 1) {
        return { 'differentDayError': true }

      }
      if (fromTime > toTime) {
        return { 'ealierError': true }

      }

      return null;
    }
  }
  get _getUserGroupId() { return this.form.get('customerGroupId') }
  

  get _getDay() { return this.form.get('day') }
  get _getToTime() { return this.form.get('toTime') }
  get _getFromTime() { return this.form.get('fromTime') }
}


